<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm6 md3 d-flex>
        <removal-chart
          chart-type="pie"
          title="TYPE"
          type="type_t"
          :items="types"
          :categories="typeCategory"
          @fetchData="fetchData"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 d-flex>
        <removal-chart
          chart-type="pie"
          title="SPECIES"
          type="species"
          :items="species"
          :categories="speciesCategory"
          @fetchData="fetchData"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 d-flex>
        <removal-chart
          chart-type="pie"
          title="CONDITION"
          type="condition"
          :items="conditions"
          :categories="conditionCategory"
          @fetchData="fetchData"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 d-flex>
        <removal-chart
          chart-type="pie"
          title="WIDTH"
          type="width"
          :items="width"
          :categories="widthCategory"
          @fetchData="fetchData"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 sm6 d-flex>
        <removal-chart
          chart-type="pie"
          title="DESIGN"
          type="design"
          :items="design"
          :categories="designCategory"
          @fetchData="fetchData"
        />
      </v-flex>
      <v-flex xs12 sm6 d-flex>
        <removal-chart
          chart-type="pie"
          title="DIRECTION"
          type="direction"
          :items="direction"
          :categories="directionCategory"
          @fetchData="fetchData"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 sm6 d-flex>
        <removal-chart
          chart-type="column"
          title="LENGTH group (m)"
          type="length"
          :items="length"
          :categories="lengthCategory"
          @fetchData="fetchData"
        />
      </v-flex>
      <v-flex xs12 sm6 d-flex>
        <removal-chart
          chart-type="column"
          title="AGE (yr)"
          type="age"
          :items="age"
          :categories="ageCategory"
          @fetchData="fetchData"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import RemovalChart from "./removal_chart";

export default {
  components: {
    RemovalChart
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      types: [],
      typeCategory: [
        { label: "farm", value: true },
        { label: "field", value: true }
      ],
      species: [],
      speciesCategory: [
        { label: "C", value: true },
        { label: "D", value: true },
        { label: "S", value: true }
      ],
      conditions: [],
      conditionCategory: [
        { label: "F", value: true },
        { label: "G", value: true },
        { label: "P", value: true }
      ],
      width: [],
      widthCategory: [
        { label: "M", value: true },
        { label: "N", value: true },
        { label: "W", value: true }
      ],
      age: [],
      ageCategory: [
        { label: "-1", value: true },
        { label: "0-10", value: true },
        { label: "11-20", value: true },
        { label: "21-30", value: true },
        { label: "31-40", value: true },
        { label: "41-50", value: true },
        { label: "51-60", value: true },
        { label: "61+", value: true }
      ],
      design: [],
      designCategory: [
        { label: "Linear", value: true },
        { label: "L_shape", value: true },
        { label: "Bracket", value: true },
        { label: "Other", value: true }
      ],
      direction: [],
      directionCategory: [
        { label: "SE-NW", value: true },
        { label: "NNE-SSW", value: true },
        { label: "E-W", value: true },
        { label: "NE-SW", value: true },
        { label: "N-S", value: true }
      ],
      length: [],
      lengthCategory: [
        { label: "0-50", value: true },
        { label: "51-100", value: true },
        { label: "101-200", value: true },
        { label: "201-400", value: true },
        { label: "401-800", value: true },
        { label: "801-1600", value: true },
        { label: "1601+", value: true }
      ],
      soilZone: [],
      soilZoneCategory: [
        { label: "Black", value: true },
        { label: "Brown", value: true },
        { label: "Gray", value: true },
        { label: "Dark Brown", value: true },
        { label: "Dark Gray", value: true }
      ]
    };
  },
  watch: {
    url: function() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let url = `${process.env.API_ROOT}/graph`;
      let body = {};
      let array = [];
      this.typeCategory.forEach(function(item) {
        if (!item.value) {
          array.push("'" + item.label + "'");
        }
      });
      if (array.length > 0) {
        body.type_t = array.join(",");
      }

      let spArray = [];
      this.speciesCategory.forEach(function(item) {
        if (!item.value) {
          spArray.push("'" + item.label + "'");
        }
      });
      if (spArray.length > 0) {
        body.species = spArray.join(",");
      }

      let cArray = [];
      this.conditionCategory.forEach(function(item) {
        if (!item.value) {
          cArray.push("'" + item.label + "'");
        }
      });
      if (cArray.length > 0) {
        body.condition = cArray.join(",");
      }

      let wArray = [];
      this.widthCategory.forEach(function(item) {
        if (!item.value) {
          wArray.push("'" + item.label + "'");
        }
      });
      if (wArray.length > 0) {
        body.width = wArray.join(",");
      }

      let dArray = [];
      this.designCategory.forEach(function(item) {
        if (!item.value) {
          dArray.push("'" + item.label + "'");
        }
      });
      if (dArray.length > 0) {
        body.design = dArray.join(",");
      }

      let dirArray = [];
      this.directionCategory.forEach(function(item) {
        if (!item.value) {
          dirArray.push("'" + item.label + "'");
        }
      });
      if (dirArray.length > 0) {
        body.direction = dirArray.join(",");
      }

      let lArray = [];
      this.lengthCategory.forEach(function(item) {
        if (!item.value) {
          lArray.push("'" + item.label + "'");
        }
      });
      if (lArray.length > 0) {
        body.length_group = lArray.join(",");
      }

      let ageArray = [];
      this.ageCategory.forEach(function(item) {
        if (!item.value) {
          ageArray.push("'" + item.label + "'");
        }
      });
      if (ageArray.length > 0) {
        body.age_yr = ageArray.join(",");
      }

      let soilArray = [];
      this.soilZoneCategory.forEach(function(item) {
        if (!item.value) {
          soilArray.push("'" + item.label + "'");
        }
      });
      if (soilArray.length > 0) {
        body.soil_zone = soilArray.join(",");
      }

      axios.post(this.url, body).then(response => {
        this.types = response.data.type_t;
        this.species = response.data.species;
        this.conditions = response.data.condition;
        this.width = response.data.width;
        this.age = response.data.age_yr;
        this.design = response.data.design;
        this.direction = response.data.direction;
        this.length = response.data.length_group;
        this.soilZone = response.data.soil_zone;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/removal_tab.vue